<ion-header>
  <ion-toolbar>
    <ion-title>Agregar información</ion-title>
    <ion-buttons slot="end" id="complete-info-close">
        <ion-button color="dark" (click)="closeModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-form [questions]="questions" (submit)="editUserData()"></app-form>
  <div class="spaceBetween">
    <button class="z-depth-2 smallButton" (click)="editUserData()">AGREGAR</button>
    <button class="z-depth-2 smallButton" (click)="cancelAskInfo()">CANCELAR</button>
  </div>
</ion-content>
